import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { useSelector } from 'react-redux';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
// import FormDialog from '../../../components/table/FormDialog';
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';
import SearchBox from '../../../components/table/SearchBox';
import FormDialog from '../../../components/table/FormDialog';
import { CommonConfig } from '../../../config/common-config';
import token from '../../../config/token';
import moment from 'moment';
// import Button from '@material-ui/core/Button';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import DialogActions from '@material-ui/core/DialogActions';
// import Dialog from '@material-ui/core/Dialog';
// import Select from '@material-ui/core/Select';
// import FormControl from '@material-ui/core/FormControl';
// import InputLabel from '@material-ui/core/InputLabel';
// import DialogContentText from '@material-ui/core/DialogContentText';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import DataTable from './DataTable';
import { useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(6),
    },
    button: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        background: '#f6f6f6',
        margin: '16px',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
    buttonView: {
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 10px',
        letterSpacing: 'normal',
        width: '24%',
        margin: '0px !important',
        background: '#4c4fa6 !important',
        color: 'white !important',
        marginRight: '14px !important',
        fontFamily: 'Rubik',
    },
    bottomLine: {
        '&:before': {
            borderBottom: '1px solid #ccc !important',
        },
    },
    pointerEvents: {
        pointerEvents: 'none !important',
        fontSize: '15px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '6px 25px',
        letterSpacing: 'normal',
    },
}));
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ItecService(props) {
    const history = useHistory();
    // const location = useLocation();
    const [searchQuery, setSearchQuery] = useState('');
    const [openBox, setOpenBox] = useState(false);
    const [deleteMsg, setDeleteMsg] = useState('');
    // const [itecMembers, setItecMembers] = useState([]);
    const triggerUseEffect = useSelector((state) => state.serviceCheckListReducer.triggerUseEffect);
    const vertical = 'top';
    const horizontal = 'center';
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // const usertype = userDetails.result && userDetails.result.data.userType;
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName);
    const dbname = tennantDetails.tennantName;
    const classes = useStyles();

    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    // const [openAssignModal, setOpenAssignModal] = useState(false);
    const tokens = token();
    const myRef = useRef();
    const [page, setPage] = useState(0);
    const [pageDetails, setPageDetails] = useState('');
    const [loading, setLoading] = useState(false);
    const [previousButton, setpreviousButton] = useState(false);
    const [nextButton, setnextButton] = useState(false);
    const [rows, setOpenTicketList] = useState([]);
    let tempArr = [];
    // const [selectedValue, setSelectedValue] = useState([]);
    // const [assigneeType, setAssigneeType] = useState({});
    const [showLoader, setShowLoader] = useState(false);

    //console.log("dbname", dbname);
    //console.log("selectedImc", selectedImc);
    //console.log("usertype", usertype);
    let headCells = [
        // { id: 'id', label: 'Sl. No' },
        { id: 'imcName', label: 'Name of the IMC' },
        { id: 'domainName', label: 'Domain Name' },
        { id: 'adminName', label: 'Admin Name' },
        { id: 'adminNumber', label: 'Admin Mobile No' },
        { id: 'openTicketsCount', label: 'No. of Open Tickets' },
        { id: 'closedTicketsCount', label: 'No. of Closed Tickets' },
    ];

    function formatDate(props) {
        return props.map((element) => {
            if (element && element.ticketTimestamp) {
                element.ticketTimestamp = moment(element.ticketTimestamp).format('DD-MM-YYYY');
                // element.ticketTimestamp = moment(element.ticketTimestamp).format('DD-MM-YYYY hh:mm:ss');
            }
        });
    }

    const getTicketList = () => {
        // console.log('aaaaaaaa')
        setLoading(true);
        setpreviousButton(true);
        setnextButton(true);
        const bearerToken = `Bearer ${userToken}`;

        let baseURL = '';
        baseURL = `${CommonConfig.dev.baseUrl5080}/api/auth/getIMCOpenCount?page=${page}&size=10&sort=domainName,asc`;

        axios
            .get(baseURL, tokens)
            .then((response) => {
                // console.log('response', response.data)
                setPageDetails(response.data);
                if (response.data.first) {
                    setpreviousButton(true);
                    setnextButton(false);
                } else if (response.data.last) {
                    setpreviousButton(false);
                    setnextButton(true);
                } else {
                    setpreviousButton(false);
                    setnextButton(false);
                }
                formatDate(response.data.content);
                setOpenTicketList(response.data.content);
            })
            .catch((error) => {
                //console.log(error);
            });
    };

    useEffect(() => {
        // let selectedImc = location.state.domainName;
        getTicketList();
    }, [userToken, page, tokens, props.statusType, props.selectedImc]);

    // console.log('rowsrows', rows)

    const filteredRow = searchQuery
        ? rows.filter((searchRow) => {
            const query = searchQuery.toLowerCase().trim();
            return headCells
                .map((col) => col)
                .some((key) => {
                    if (key.isConcat && searchRow[key.id]) {
                        const subdata = searchRow[key.id];
                        const mergedData = key.concatElem.map((concatdata) => {
                            return concatdata.split('.').reduce((acc, item) => {
                                if (Object.prototype.hasOwnProperty.call(acc, item)) {
                                    if (typeof acc[item] !== 'object') {
                                        return acc[item].toString().toLowerCase().includes(query);
                                    }
                                    return acc[item];
                                }

                                return false;
                            }, subdata);
                        });
                        //console.log(mergedData,"mergeData");

                        return mergedData[0];
                    }
                    if (searchRow[key.id]) {
                        return searchRow[key.id].toString().toLowerCase().includes(query);
                    } else {
                        return false;
                    }
                });
        })
        : rows;


    const handleSearchQuery = (searchData) => {
        setSearchQuery(searchData);
    };
    const navigate = () => {
        history.push('/menu/raise-ticket');
    };

    const handleSave = () => { };

    const handleClose = () => {
        setOpenBox(false);
    };

    const clearField = () => {
        setSearchQuery('');
        // setSearchData([]);
        // setPage(0);
        // getCandidates();
        // console.log('clearclear')
    }

    const handleCount = (val) => {
        if (val === 'prev') {
            if (!pageDetails.first) {
                setPage((page) => page - 1);
            }
        }

        if (val === 'next') {
            if (!pageDetails.last) {
                setPage((page) => page + 1);
            }
        }
    };

    const handleRowChange = (row) => {
        console.log('AdvithRow', row);
        // props.handleIMCType(row.imcName)
        console.log("row", row.domainName);
        let domainname = row.domainName;

        history.push({
            pathname: '/menu/view-tickets',
            state: { domainname },
        });
    }

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            <Snackbar open={openBox} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {deleteMsg}
                </Alert>
            </Snackbar>

            <Card className="custom-table">
                <>
                    <div>
                        {/* <Grid container className="main-container field-container"></Grid> */}

                        <CardContent className="card-title-display">
                            <Grid item xs={12} sm={8}>
                                <Typography className="card-title">IMC wise Support tickets</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} className="card-search">
                                <div className="search-field">
                                    <SearchBox searchQuery={searchQuery} onChange={handleSearchQuery} clearField={clearField} placeholder="Search..." />
                                </div>
                            </Grid>
                            <FormDialog row={[]} pageName="core" show="AddIcon" />
                        </CardContent>
                    </div>
                    <CardContent className="card-table-display">
                        {rows && filteredRow.length > 0 ? (
                            <>
                                <DataTable
                                    rows={filteredRow}
                                    headCells={headCells}
                                    saveRow={handleSave}
                                    axiosConfig={bearerToken}
                                    tennantName={dbname}
                                    handleCount={handleCount}
                                    //id={invoiceId}
                                    pageName="core"
                                    action
                                    pageDetails={pageDetails}
                                    prvnxtbt={{ prvBt: previousButton, nxtBt: nextButton }}
                                    imcType={props.selectedImc}
                                    handleRowChange={handleRowChange}
                                />
                            </>
                        ) : (
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            )}
                    </CardContent>
                </>
            </Card>
        </>
    );
}
export default ItecService;
